module.exports = __webpack_public_path__ + "static/media/domnic-brown.aca44ca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/domnic-brown.png
// module id = 807
// module chunks = 108